export class LendingAPIError extends Error {
    data: any;

    constructor(data: any) {
        super('Lending API Error');

        this.data = data;
    }
}
